export enum APIDataStatus {
    ACTIVE = "ACTIVE",
    DELETED = "DELETED"
}

export interface APIDataModel {
    id: number
    ownerId: number
    path: string
    mimeType?: string
    signedUrl?: string
    status: APIDataStatus
    created: Date
    updated: Date
}

export function getDataID(model: APIDataModel): string {
    return String(model.id)
}

export function getMillisecondsUntilExpire(urlString: string): number {
    const url = new URL(urlString)
    const expire = parseInt(url.searchParams.get("Expires") || "", 10) * 1000

    return expire - Date.now()
}

export function isExpiredSignedUrl(urlString: string): boolean {
    return getMillisecondsUntilExpire(urlString) <= 0
}

export function isDataUrl(url: string): boolean {
    return url.match(/^data:\/\/(.*)$/) !== null
}

export function extractDataUrlPath(
    url: string | undefined
): string | undefined {
    const matched = url?.match(/^data:\/\/(.*)$/)

    return matched ? matched[1] : undefined
}

export function getDataUrl({ ownerId, path }: APIDataModel): string {
    return `data://${ownerId}/${path}`
}
